import { NORMAL, TYPE_FACTURE } from '@/configuration/devisConf';
import genererEcheancierAuto from '@/services/commande/echeancierFacturation/genererEcheancierAuto';

function getEcheancierAndReferenceEcheancier(ligne, commande) {
  if (ligne.type === NORMAL && commande.type !== TYPE_FACTURE) {
    const echeancier = genererEcheancierAuto(
      [ligne], commande.datePremierAffichage, commande.dateDevisCommande,
    );
    commande.echeanciers.push(echeancier);
    ligne.referenceEcheancier = echeancier.referenceEcheancier;
  }
}

export function addReferenceEcheancierToLigneCommande(ligne, commande) {
  getEcheancierAndReferenceEcheancier(ligne, commande);
  if (!ligne.lignesCommande) return;
  ligne.lignesCommande.forEach((ligneEnfant) => {
    ligneEnfant.dateDebut = ligne.dateDebut;
    ligneEnfant.dateFin = ligne.dateFin;
    ligneEnfant.ligneReseau = ligne.ligneReseau;
    getEcheancierAndReferenceEcheancier(ligneEnfant, commande);
  });
}

export function addReferenceEcheancierToLigneCommandeWithoutReference(devis) {
  const addReferenceToAllLignes = devis.echeanciers.length === 0;
  devis.lignesCommande.forEach((ligne) => {
    if (ligne.referenceEcheancier && !addReferenceToAllLignes) return;
    getEcheancierAndReferenceEcheancier(ligne, devis);
    if (!ligne.lignesCommande) return;
    ligne.lignesCommande.forEach((ligneEnfant) => {
      if (ligneEnfant.referenceEcheancier && !addReferenceToAllLignes) return;
      ligneEnfant.dateDebut = ligne.dateDebut;
      ligneEnfant.dateFin = ligne.dateFin;
      ligneEnfant.ligneReseau = ligne.ligneReseau;
      getEcheancierAndReferenceEcheancier(ligneEnfant, devis);
    });
  });
}
